import React from 'react';

const IntroSection = () => {
    return (
        <div className="container text-calcite-text-2 my-12 m:flex items-center">
            <div className="m:w-3/5 mb-6">
                <h3 className="text-4xl">Plan for the future...now.</h3>

                <p className="mt-6">
                    Understanding how our world has changed can provide insight into building a more sustainable and prosperous future. By analyzing historic global land cover data and observing change over time, we can make fundamental predictions and forecast growth patterns for the future.
                </p>

                <p className="mt-6">
                    A collaboration between <a href="https://clarklabs.org/about/" target="_blank">Clark Labs at Clark University</a> and Esri aims to predict land cover change in 2050. By utilizing decades of satellite observation data from the European Space Agency (ESA) Climate Change Initiative (CCI), a new series of maps has been developed and released for open use. The resulting map series classifies land cover by type and vulnerability to human development.
                </p>
            </div>

        </div>
    );
};

export default IntroSection;
